module.exports = __webpack_public_path__ + "fonts/Inter-200-latin-ext34.2685934.woff2";